import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ShareLink from '../share-link/share-link';
import css from './share.css';
import generateShareLink from './generate-share-link';
import generateShareIcon from './generate-share-icon';
import shareWindowOpen from './share-window-open';

const Share = ({ inverse, longtext, platforms, text, url, onShare }) => {
  function handleClick(e, platform) {
    e.preventDefault();
    const params = {
      platform,
      url,
      text,
      longtext,
    };
    shareWindowOpen(generateShareLink(params));
    onShare(params);
  }

  return (
    <ul className={classnames(css['ds-share-list'])}>
      {platforms.map(platform => {
        const Icon = generateShareIcon(platform);
        return (
          <li key={platform} id={platform}>
            <ShareLink
              onClick={e => handleClick(e, platform)}
              aria-label={`Share on ${platform}`}
              icon={<Icon />}
              inverse={inverse}
              href='#'
            />
          </li>
        );
      })}
    </ul>
  );
};

Share.defaultProps = {
  inverse: null,
  longtext: '',
  text: '',
  onShare: () => {},
};

Share.propTypes = {
  inverse: PropTypes.bool,
  longtext: PropTypes.string,
  platforms: PropTypes.arrayOf(PropTypes.string).isRequired,
  text: PropTypes.string,
  url: PropTypes.string.isRequired,
  onShare: PropTypes.func,
};

export default Share;
